import { Avatar } from '@mui/material';
import React from 'react';
import { ImageCroppingPresets, useMediaAsset } from '../../modules/Media/MediaUtils';
import { getInitials } from '../../services/Utils';
export const ProfilePicture = ({ user }) => {

    const { assetSrc } = useMediaAsset({ id: user?.meta?.profilePic, network: false, args: ImageCroppingPresets.thumbnail });
    let name;
    if (user?.lastName && user?.firstName) name = user.firstName + ' ' + user.lastName;
    else if (user?.firstName) name = user.firstName;
    else if (user?.lastName) name = user.lastName;

    return (
        <Avatar src={assetSrc}>{getInitials(user?.firstName + ' ' + user?.lastName)}</Avatar>
    )
}